const NS = 'StarRibbonWidget';
const CLS = 'starRibbonWidget';

export class StarRibbonWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.bookmarkApi = this.$element.data('bookmarkApi');
		this.unbookmarkApi = this.$element.data('unbookmarkApi');
		this.id = this.$element.data('id');

		this.$element.on('click', () => {
			if(this.$element.data('readonly')) {
				return;
			}

			let url;
			if(this.$element.attr('data-bookmarked') === 'true') {
				url = `${this.unbookmarkApi}?id=${this.id}`;
				$.ajax({
					type: 'POST',
					url: url,
					success: (_response, _textStatus, jqXHR) => {
						if(jqXHR.status === 204) {
							this.$element.attr('data-bookmarked', false);
							$('.resourcesBlock[data-id=' + this.id + ']').parent().css({ 'display': 'none', 'position': 'absolute' });
						}
					}
				});
			}
			else {
				url = `${this.bookmarkApi}?id=${this.id}`;
				$.ajax({
					type: 'POST',
					url: url,
					success: (_response, _textStatus, jqXHR) => {
						if(jqXHR.status === 204) {
							this.$element.attr('data-bookmarked', true);
						}
					}
				});
			}
		});
	}
}
